import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { MarketingShell, M } from "@/components/MarketingShell";
import { getPost } from "@/content/blog";
import { ShareBar } from "@/components/ShareBar";

export const Route = createFileRoute("/blog/$slug")({
  loader: ({ params }) => {
    const post = getPost(params.slug);
    if (!post) throw notFound();
    return post;
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) {
      return { meta: [{ title: "Post not found — Tiger's Eye" }, { name: "robots", content: "noindex" }] };
    }
    const url = `https://tigerseye.app/blog/${params.slug}`;
    return {
      meta: [
        { title: `${loaderData.title} — Tiger's Eye` },
        { name: "description", content: loaderData.description },
        { property: "og:title", content: loaderData.title },
        { property: "og:description", content: loaderData.description },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  notFoundComponent: () => (
    <MarketingShell>
      <h1 className="text-3xl" style={{ fontFamily: M.SERIF }}>Post not found</h1>
      <Link to="/blog" className="mt-4 inline-block underline">Back to the blog</Link>
    </MarketingShell>
  ),
  component: BlogPostPage,
});

function BlogPostPage() {
  const post = Route.useLoaderData();
  return (
    <MarketingShell>
      <Link to="/blog" className="text-sm underline" style={{ color: M.INK_SOFT }}>← All posts</Link>
      <h1 className="mt-6 text-4xl leading-tight" style={{ fontFamily: M.SERIF }}>{post.title}</h1>
      <p className="mt-3 text-xs" style={{ color: M.INK_FAINT }}>
        {post.date} · {post.readMinutes} min read
      </p>
      <article className="mt-8 space-y-6 leading-relaxed" style={{ color: M.INK_SOFT }}>
        {post.body.map((b, i) => (
          <section key={i}>
            {b.heading && (
              <h2 className="mb-2 text-xl" style={{ fontFamily: M.SERIF, color: M.INK }}>{b.heading}</h2>
            )}
            <p>{b.text}</p>
          </section>
        ))}
      </article>
      <ShareBar title={post.title} url={`https://tigerseye.app/blog/${post.slug}`} />
      <div className="mt-12 rounded-lg border p-6" style={{ borderColor: M.RULE, background: M.SURFACE }}>
        <p className="font-semibold" style={{ color: M.INK }}>Get honest feedback on your draft — free.</p>
        <p className="mt-1 text-sm" style={{ color: M.INK_SOFT }}>
          Free for the first 49 students, then £4.95 per term.
        </p>
        <Link
          to="/free-review"
          className="mt-4 inline-block rounded-md px-4 py-2 text-sm font-medium"
          style={{ background: M.INK, color: M.BG }}
        >
          Claim your free review
        </Link>
      </div>
    </MarketingShell>
  );
}
